module.exports = "<div v-show=\"notifications.length > 0\" class=\"editorUi-notificationsContainer\">\n  <component\n    v-for=\"(notification, index) in notifications\"\n    is=\"notification\"\n    :notification=\"notification\"\n    :index=\"index\"\n    :key=\"notification.id\">\n  </component>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/global-view/notifications/template.html
// module id = YZfv
// module chunks = 0